import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PalantirIconComponent } from '../icon/icon.component';

@Component({
  selector: 'palantir-stars',
  templateUrl: './stars.component.html',
  styleUrls: ['./stars.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [PalantirIconComponent],
})
export class PalantirStarsComponent {
  @Input({ required: true }) public value: number = 0;
}
